import api from 'api'
import { ICertificate } from 'models/certificate.model'
import { decamelizeThatDontBreaksFile, ObjectToFormDataWithFiles } from 'helpers/converters.helper'

const editCertificate = (data: ICertificate, id: number) => {
  const decamelizeData = decamelizeThatDontBreaksFile(data)
  const formData = ObjectToFormDataWithFiles(decamelizeData, 'certificate')
  return api.put(`/administration/certificates/${id}`, formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
}

export default editCertificate